"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function StatsSection() {
  const { t } = useLanguage();

  const stats = [
    { value: "$89", labelKey: "sliding.stat1Label" },
    { valueKey: "sliding.stat2Value", labelKey: "sliding.stat2Label" },
    { valueKey: "sliding.stat3Value", labelKey: "sliding.stat3Label" },
    { value: "12+", labelKey: "sliding.stat4Label" },
  ];

  return (
    <section className="bg-primary text-white py-10 px-4 md:px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {stats.map((s, i) => (
          <div key={i} className="text-center">
            <p className="text-2xl md:text-3xl font-bold">
              {"value" in s ? s.value : t(s.valueKey as string)}
            </p>
            <p className="text-sm text-white/80 mt-1">{t(s.labelKey)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}